import React from 'react';
import { SignInButton, UserButton, useAuth } from '@clerk/clerk-react';
import { Sparkle } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import VideoAnalyzer from '../components/VideoAnalyzer';
import './AppWorkspacePage.css';

interface AppWorkspaceShellProps {
  clerkEnabled: boolean;
  isSignedIn: boolean;
}

const AppWorkspaceShell: React.FC<AppWorkspaceShellProps> = ({ clerkEnabled, isSignedIn }) => {
  return (
    <div className="workspace-page">
      <header className="workspace-header">
        <div className="workspace-brand">
          <span>VidInsight Studio</span>
          <small>Explainer Video Case Study Engine</small>
        </div>

        <div className="workspace-header-actions">
          <Link to="/" className="workspace-link">
            Home
          </Link>

          {clerkEnabled ? (
            isSignedIn ? (
              <div className="workspace-user-pill">
                <Sparkle size={14} weight="duotone" aria-hidden="true" />
                <span>Account protected</span>
                <UserButton />
              </div>
            ) : (
              <SignInButton mode="modal" forceRedirectUrl="/app">
                <button type="button" className="workspace-signin-btn">
                  Sign in
                </button>
              </SignInButton>
            )
          ) : (
            <span className="workspace-local-badge">Local mode</span>
          )}
        </div>
      </header>

      <VideoAnalyzer />
    </div>
  );
};

const AppWorkspacePageWithClerk: React.FC = () => {
  const { isSignedIn } = useAuth();
  return <AppWorkspaceShell clerkEnabled={true} isSignedIn={Boolean(isSignedIn)} />;
};

const AppWorkspacePageWithoutClerk: React.FC = () => {
  return <AppWorkspaceShell clerkEnabled={false} isSignedIn={true} />;
};

const AppWorkspacePage: React.FC = () => {
  const clerkEnabled = Boolean(process.env.REACT_APP_CLERK_PUBLISHABLE_KEY);
  return clerkEnabled ? <AppWorkspacePageWithClerk /> : <AppWorkspacePageWithoutClerk />;
};

export default AppWorkspacePage;
